import React from 'react';

import { TableContainer, Table, Thead, Tr, Th, Tbody, Skeleton } from '@ecoinvent/ui';

import NoResultCard from 'components/UI/NoResultCard';
import { V4LciaScore, V4TransformedLciaMethod } from 'hooks/data/datasets/V4/lcia/types';

import V4ImpactAssessmentRow from './V4ImpactAssessmentRow';

type Props = {
  isLoading?: boolean;
  isV4Loading?: boolean;
  uprId: string;
  selectedMethod: V4TransformedLciaMethod;
  V4LciaScores?: V4LciaScore[];
};

const V4ImpactAssessmentTable = ({ isLoading, isV4Loading, selectedMethod, V4LciaScores }: Props) => {
  const isAnythingLoading = isLoading || isV4Loading;

  return (
    <Skeleton isLoaded={!isLoading}>
      <TableContainer whiteSpace={'break-spaces'}>
        <Table size="sm">
          <Thead>
            <Tr>
              <Th pl={0}>Impact category</Th>
              <Th align="left">Indicator</Th>
              <Th isNumeric whiteSpace={'nowrap'}>
                Impact Score
              </Th>
              <Th align="left">Unit</Th>
              <Th align="left" />
            </Tr>
          </Thead>
          {!isAnythingLoading && V4LciaScores && V4LciaScores.length > 0 && (
            <Tbody>
              {V4LciaScores.map((row) => {
                return <V4ImpactAssessmentRow selectedMethod={selectedMethod} key={row.id} score={row} />;
              })}
            </Tbody>
          )}
          {!isLoading && V4LciaScores?.length === 0 && (
            <Tbody>
              <NoResultCard>No Results Found</NoResultCard>
            </Tbody>
          )}
        </Table>
      </TableContainer>
    </Skeleton>
  );
};

export default V4ImpactAssessmentTable;
